import type { QuotingPortal } from 'lib/hosts/quoting/interface';
import { Undef } from 'types/UtilityTypes';

export const PrincetonTmxSubmitAction = 'princeton-tmx-submit-quote';

function getPrincetonTmxRoute(urlStr: string): Undef<string> {
  try {
    const url = new URL(urlStr);
    const host = url.hostname.toLowerCase();
    if (!host.endsWith('.princetontmx.com') && host !== 'princetontmx.com') {
      return undefined;
    }
    return `${url.pathname}${url.hash}`.toLowerCase();
  } catch {
    return undefined;
  }
}

export function isPrincetonTmxLoadBoardUrl(urlStr: Undef<string>): boolean {
  if (!urlStr) return false;

  const route = getPrincetonTmxRoute(urlStr);
  return Boolean(route?.includes('/carrierweb/spot-rate-load-board'));
}

export function isPrincetonTmxUrl(urlStr: Undef<string>): boolean {
  return isPrincetonTmxLoadBoardUrl(urlStr);
}

export class PrincetonTmx implements QuotingPortal {
  submitAction = PrincetonTmxSubmitAction;

  canSubmit(tab: Undef<chrome.tabs.Tab>, _html: string): boolean {
    return isPrincetonTmxLoadBoardUrl(tab?.url);
  }
}
